/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateGetParamsResponse {
    getFixupPrototypeFunction() { return TemplateGetParamsResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateGetParamsResponse>): TemplateGetParamsResponse {
        let obj = Object.assign(new TemplateGetParamsResponse(), model);
        TemplateGetParamsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateGetParamsResponse>): TemplateGetParamsResponse {
        if (!model) return null;
        return TemplateGetParamsResponse.newInstance(<TemplateGetParamsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateGetParamsResponse) {
        if (!obj) return;

        models.TemplateGetParamsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateGetParamsResponse): boolean {
        Object.setPrototypeOf(obj, TemplateGetParamsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.CloudAccountDetailsResponse.fixupPrototype(val);
            }
        }
    }

    /**
     * Arguments to the template
     */
    args: any;

    /**
     * Cloud account details to execute the template
     */
    cloud_accounts: Array<models.CloudAccountDetailsResponse>;

}
